<div class="temp-item" (click)="setTemplate()">
  <div class="img-container">
    <img [src]="temp?.android_image_url || './assets/img/default_temp.png'" />
  </div>
  <div class="cat-title">{{ temp?.title }}</div>
  <div class="temp-title">{{ getCategory(temp?.category) }}</div>
</div>
